/*
 *
 * RegAttemptsExceededModal
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 08-Oct-2024
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.shared.registration.blocked'
      defaultMessage='Impossibile procedere con la registrazione'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.registration.attemptsExceededModal.description'
      defaultMessage='Hai esaurito i tentativi di registrazione per oggi. Riprova tra 24 ore.'
    />
  ),
  descriptionNexi: (
    <PortalMessage
      id='t.app.registration.confirmPhone.error.expiredCodeModal.description'
      defaultMessage='Hai esaurito i tentativi di registrazione per oggi. Riprova tra 24 ore.'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.registration.confirmPhone.error.expiredCodeModal.buttonLabel'
      defaultMessage='Ok, Ho Capito'
    />
  )
}

export default formattedMessage
